// PATH: src/components/ui/PageHeader.tsx
import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";

interface Props {
  title: React.ReactNode;
  /** Une phrase : à quoi sert l'écran. */
  subtitle?: React.ReactNode;
  /** Boutons de la page, à droite (le principal en dernier). */
  actions?: React.ReactNode;
  /** Ligne sous le titre (filtres, onglets). */
  children?: React.ReactNode;
}

/** En-tête commun à toutes les pages : titre, sous-titre, actions. */
export const PageHeader: React.FC<Props> = ({ title, subtitle, actions, children }) => {
  React.useEffect(() => {
    if (typeof title === "string") document.title = `${title} · Tilmicode Contenus`;
  }, [title]);
  return (
    <Box sx={{ mb: 3 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={2}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h1" component="h1">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5, maxWidth: 760 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && (
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap sx={{ flexShrink: 0 }}>
            {actions}
          </Stack>
        )}
      </Stack>
      {children && <Box sx={{ mt: 2.5 }}>{children}</Box>}
    </Box>
  );
};

export default PageHeader;
